import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Icon } from "common-components";
import { Spin } from "antd";
import { Loading3QuartersOutlined } from "@ant-design/icons";
import openNotificationWithIcon from "utils/hooks/useNotification";
import { getErrorReportQuestion } from "api/errorReport";
import { UiModalTitle, StyledQuestionPreview } from "./QuestionPreviewModal.style";

/** 錯題回報 API 以 error 欄位回傳狀態碼 */
const API_SUCCESS_CODE = 200;

/** 只顯示這些 metadata，並依此順序排列 */
const DISPLAY_META_CODES = [
	"OUTPUT", // CMS編號
	"QUES_TYPE", // 題型
	"ANSWER", // 答案數
	"SPLIT_ANSWER", // 拆解答案數
	"CMS_LastUpdateTime", // 最後更新時間
	"YEAR", // 學年度
	"VOLUME", // 冊次
	"SOURCE_FILE_NAME", // 來源檔名
];

const toDisplayMetadata = (metadata = []) =>
	DISPLAY_META_CODES.map((code) => metadata.find((meta) => meta.code === code)).filter(Boolean);

export const QuestionPreviewModal = ({ report, onCancel }) => {
	const [question, setQuestion] = useState(null);
	const [isLoading, setIsLoading] = useState(false);

	const { eduSubject, questionUID } = report;

	useEffect(() => {
		const fetchQuestion = async () => {
			try {
				setIsLoading(true);
				const { error, data, message } = await getErrorReportQuestion(eduSubject, questionUID);
				if (error !== API_SUCCESS_CODE) {
					openNotificationWithIcon("error", message);
					return;
				}
				setQuestion(data || null);
			} catch (error) {
				openNotificationWithIcon("error", error?.message || error);
			} finally {
				setIsLoading(false);
			}
		};

		fetchQuestion();
	}, [eduSubject, questionUID]);

	return (
		<Modal
			title={<UiModalTitle>基本資料</UiModalTitle>}
			visible={true}
			width="500px"
			onCancel={onCancel}
			footer={
				<Button variant="white" full={false} onClick={onCancel}>
					關 閉
				</Button>
			}>
			<StyledQuestionPreview>
				{isLoading ? (
					<div className="loading">
						<Spin indicator={<Loading3QuartersOutlined spin={true} />} size="large" />
					</div>
				) : question ? (
					<div className="infoList">
						{toDisplayMetadata(question.metadata).map((meta) => (
							<div className="infoRow" key={meta.code}>
								<div className="infoLabel">{`${meta.name}:`}</div>
								<div className="infoValue">
									{(meta.content || []).map((content, index) => (
										<span key={`${meta.code}${index}`}>{content.name}</span>
									))}
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="empty">查無題目資料</div>
				)}
			</StyledQuestionPreview>
		</Modal>
	);
};

QuestionPreviewModal.propTypes = {
	report: PropTypes.object,
	onCancel: PropTypes.func,
};
